module.exports = "/_next/static/videos/slide-1-8fa344a31a961e420c203bd3d3b3d03b.webm";